module.exports = function looseSchema(schema) {
  const { oneOf, anyOf, ...prevSchema } = schema
  const type = Array.isArray(schema.type) ? schema.type : [schema.type]
  const nextSchema = {
    ...prevSchema,
  }

  if (oneOf) {
    nextSchema.anyOf = oneOf.map(oneOfSchema => looseSchema(oneOfSchema))
  }

  if (anyOf) {
    nextSchema.anyOf = anyOf.map(anyOfSchema => looseSchema(anyOfSchema))
  }

  if (type.includes('object')) {
    if (prevSchema.properties) {
      nextSchema.properties = Object.fromEntries(
        Object.entries(prevSchema.properties).map(([key, schema]) => [key, looseSchema(schema)])
      )
    }

    if (prevSchema.required) {
      nextSchema.required = []
    }
  }

  if (type.includes('array')) {
    if (prevSchema.items) {
      nextSchema.items = looseSchema(prevSchema.items)
    }
  }

  return nextSchema
}
